export default __webpack_public_path__ + "static/media/thanks.d514edfe.svg";